import { SWReactIcons } from "@similarweb/icons";
import { Banner } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";
import { NotificationBannerContainer } from "app/pages/website-analysis/TrafficAndEngagement/Components/single/StyledComponents";

export const AlternativeSourcesNotificationBanner = () => {
    const bannerTitle = "website.analysis.traffic.and.engagement.alternative.data.banner.notification.title";
    return (
        <NotificationBannerContainer>
            <Banner
                title={i18nFilter()(bannerTitle)}
                CustomIcon={
                    <SWReactIcons
                        iconName="info"
                        size="xs"
                    />
                }
                CustomButton={<span />}
                className={"alternative-notification-banner"}
            />
        </NotificationBannerContainer>
    );
};
